import dayjs from 'dayjs'

export const DATE_RANGE_OPTIONS = [
  { label: 'Last Month', value: 'last_month' },
  { label: 'Last Week', value: 'last_week' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Today', value: 'today' },
  { label: 'Tomorrow', value: 'tomorrow' },
  { label: 'This Week', value: 'this_week' },
  { label: 'This Month', value: 'this_month' },
  { label: 'Custom Range', value: 'custom' },
]

export const getDateRangeForMode = (mode: string): { start: Date; end: Date } => {
  switch (mode) {
    case 'last_month':
      return {
        start: dayjs().subtract(1, 'month').startOf('month').toDate(),
        end: dayjs().subtract(1, 'month').endOf('month').toDate(),
      }
    case 'last_week':
      return {
        start: dayjs().subtract(1, 'week').startOf('week').toDate(),
        end: dayjs().subtract(1, 'week').endOf('week').toDate(),
      }
    case 'yesterday':
      return {
        start: dayjs().subtract(1, 'day').startOf('day').toDate(),
        end: dayjs().subtract(1, 'day').endOf('day').toDate(),
      }
    case 'today':
      return {
        start: dayjs().startOf('day').toDate(),
        end: dayjs().endOf('day').toDate(),
      }
    case 'tomorrow':
      return {
        start: dayjs().add(1, 'day').startOf('day').toDate(),
        end: dayjs().add(1, 'day').endOf('day').toDate(),
      }
    case 'this_week':
      return {
        start: dayjs().startOf('week').toDate(),
        end: dayjs().endOf('week').toDate(),
      }
    case 'this_month':
      return {
        start: dayjs().startOf('month').toDate(),
        end: dayjs().endOf('month').toDate(),
      }
    default:
      return {
        start: dayjs().toDate(),
        end: dayjs().add(7, 'day').toDate(),
      }
  }
}

export const detectDateRangeMode = (
  dateRange?: { start?: Date; end?: Date },
): { mode: string | null; dateRange: { start: Date; end: Date } | null } => {
  if (!dateRange?.start && !dateRange?.end) {
    return { mode: null, dateRange: null }
  }

  const modes = [
    'last_month',
    'last_week',
    'yesterday',
    'today',
    'tomorrow',
    'this_week',
    'this_month',
  ] as const

  for (const mode of modes) {
    const range = getDateRangeForMode(mode)
    if (
      dayjs(dateRange?.start).isSame(range.start, 'day') &&
      dayjs(dateRange?.end).isSame(range.end, 'day')
    ) {
      return { mode, dateRange: range }
    }
  }

  return {
    mode: 'custom',
    dateRange: {
      start: dateRange?.start ?? dayjs().toDate(),
      end: dateRange?.end ?? dayjs().add(7, 'day').toDate(),
    },
  }
}
